import { z } from 'zod'
import type {HttpClient} from "@jantm/model-core";
import {createScheduleApi} from "@/api/wiser/schedule.ts";
import {defineModel} from '@jantm/model-core'
import ScheduleFullListItem from "@/templates/Wiser/ScheduleFullListItem.vue";
import ScheduleFullDetail from "@/templates/Wiser/ScheduleFullDetail.vue";
import {optionalStringSchema} from "@/types/global.ts";
export const scheduleSchema = z.object({
  id: z.int(),
  title: optionalStringSchema,
})

export type Schedule = z.infer<typeof scheduleSchema>

export const scheduleCollectionSchema = z.array(scheduleSchema)

export type ScheduleCollection = z.infer<typeof scheduleCollectionSchema>

export const scheduleFilterSchema = z.object({
  fields: z.array(scheduleSchema.keyof()).nullish().optional(),
  page: optionalStringSchema.default('1'),
  perPage: optionalStringSchema.default('25'),
  filters: optionalStringSchema,
})
export type ScheduleFilter = z.infer<typeof scheduleFilterSchema>

export type ScheduleFilters = {
  id?: string
  title?: string
}

export interface CreateScheduleModelOptions {
  client: HttpClient
  /** Override when this model does not live at `/api/schedules`. */
  endpoint?: string
}

export function createScheduleModel(options: CreateScheduleModelOptions) {
  return defineModel({
    name: 'Schedule',
    schema: scheduleSchema,
    collectionSchema: scheduleCollectionSchema,
    filterSchema: scheduleFilterSchema,
    api: createScheduleApi(options.client, options.endpoint),
    identify: (schedule: Schedule) => String(schedule.id),
    templates: { FullListItem: ScheduleFullListItem, FullDetail: ScheduleFullDetail },
    // toItems: (collection) => Object.entries(collection.items).map(([, v]) => v),
    // toTotal: (collection => collection.metadata?.total)
  })
}

export type ScheduleModel = ReturnType<typeof createScheduleModel>

declare module '@jantm/model-core' {
  interface ModelRegistry {
    Schedule: ScheduleModel
  }
}
